import { singleline } from "@core/foundation/string";
import { z } from "@core/zod";

export const BashCommandConditionSchema = z.object(
  {
    blocking: z.boolean().default(false),
    kind: z.literal("bashCommand"),
    regexp: z.regexp(),
  },
  {
    blocking: singleline`
      Whether the memory blocks the command — denied and injected before it runs
      — rather than following it, injected beside its result, as it does unless
      set.
    `,
    kind: "The condition's kind, firing on a Bash command.",
    regexp: "The JavaScript regexp the command must match.",
  },
);
